// extracted by mini-css-extract-plugin
export var label = "_gs-2";
export var slideContainer = "_gs-0";
export var slider = "_gs-1";